import { render, staticRenderFns } from "./filtered-reviews-preview.vue?vue&type=template&id=54cf0556&scoped=true"
import script from "./filtered-reviews-preview.vue?vue&type=script&lang=js"
export * from "./filtered-reviews-preview.vue?vue&type=script&lang=js"
import style0 from "./filtered-reviews-preview.vue?vue&type=style&index=0&id=54cf0556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf0556",
  null
  
)

export default component.exports